import { lazy, Suspense, useState } from 'react';
import { useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAiStatus } from '../../ai';

// The panel (the assistant, Ask, the answer view and its CSS) is its own chunk.
const AiPanel = lazy(() => import('./AiPanel'));

/**
 * §32 M16 the Assistant button in the top bar — only when AI is on for this person. Kept apart from the other AI
 * buttons: this one is in every page's first download.
 */
export function AskButton() {
  const { t } = useTranslation();
  const status = useAiStatus();
  const project = useMatch('/p/:projectId/*')?.params.projectId ?? null;
  const [open, setOpen] = useState(false);
  if (!status.data?.enabled) return null;
  return (
    <>
      <button className="btn ai-ask-btn" aria-expanded={open} onClick={() => setOpen(!open)}>
        ✨ {t('ai.assistant')}
      </button>
      {open && (
        <Suspense fallback={null}>
          <AiPanel projectId={project} status={status.data} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
